module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("We are grateful to all our contributors, who met deadlines, submitted outstanding essays and sermons, and offered keen insights along the way, and to our terrific editors, Michael Thomson, Jenny Hoffman, and Ryan Davis, who shepherded this project to completion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I (JBM) am grateful to my longtime friend and coeditor, Scot McKnight, for his generous kindness in allowing me to dedicate our volume to my parents, who died within a few days of each other in 2017. It was a difficult time for my brother Steven, my sister Maria, and me as we handled complicated medical decisions. We cried, prayed, cried some more, and consoled each other. It was, to say the least, a family effort.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two memorable events in my childhood played a part in launching me into scholarship. First, my mother was the epitome of diligence and perfection. While in grade school, I often rushed through my homework to be able to go outside and play with my friends. That usually meant sloppy and crinkled loose-leaf pages of homework. One day my mother, in a moment of exasperation, took out the ironing board, heated up the iron, and began to iron my pages. I couldn’t believe my eyes. “You won’t hand in anything sloppy anymore, Joseph.” I was in second grade. I still remember that day.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, my father worked an extra job to be able to purchase a brand-new set of World Book Encyclopedia, those 1960s green-and-white volumes ranging from A to Z. My father also brought a two-tier bookshelf for the encyclopedias. I thought the Library of Congress had arrived at the Modica home! I was in the third grade, and I began to read every volume from cover to cover. Unbeknownst to me, however, my parents realized that the H volume contained male and female human anatomy transparencies. They knew I wasn’t ready for “the conversation,” so they hid the volume for a while. They each had wisdom and a great sense of humor.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("May they both rest in peace.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f7eb17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 69
// module chunks = 0